export default "__VITE_ASSET__c98ce405__"